export default __webpack_public_path__ + "static/media/SN1-2.9f8bec56.jpg";